<button
  #trigger
  type="button"
  class="trigger"
  [attr.data-appearance]="appearance"
  [attr.data-size]="size"
  [attr.readonly]="completed || null"
  [attr.is-placeholder]="!(value$ | async) || null"
  [disabled]="completed || (disabled$ | async)"
  (click)="toggle()"
  (blur)="onBlur($event)"
>
  <ng-container *ngIf="value$ | async as val; else placeholderText">{{ getLabelForValue(val) }}</ng-container>
  <ng-template #placeholderText>{{ placeholder }}</ng-template>
</button>
<ul class="panel" *ngIf="isOpen">
  <li
    *ngFor="let option of options"
    class="option"
    [class.selected]="option.value === (value$ | async)"
    (mousedown)="selectOption($event, option)"
  >
    {{ option.label }}
  </li>
</ul>
<lib-input-icon
  type="select-arrow"
  class="overlapping-icon icon-arrow"
  [size]="size"
  [class.disabled]="completed || (disabled$ | async)"
></lib-input-icon>
<lib-input-icon type="warning" class="overlapping-icon icon-warning" [size]="size"></lib-input-icon>
